import * as z from "zod";
import { MerchantDashboardSummarySchema } from "./merchant-dashboard-fields";

export const listMerchantDashboards = {
  name: "listMerchantDashboards" as const,
  input: z.object({}),
  output: z.object({ dashboards: z.array(MerchantDashboardSummarySchema) }),
};
